import { ConstantUtils } from "../../../utils/ConstantUtils";
import { SoapUtils } from "../../../utils/SoapUtils";

export interface Folder {
  parentPath?: string;
  type?: string;
  id?: string;
  aclh?: string;
  comment?: string;
  folderType?: string;
  folderLinkType?: string;
  folderTypeName?: string;
  typeFormId?: string;
  formId?: string;
  formName?: string;
  referenceId?: string;
  name?: string;
  name1?: string;
  name2?: string;
  name3?: string;
  formValues?: string;
  messageGroup?: string;
  messageDefault?: string;
  guiAction?: string;
  contactType?: string;
  customState?: string;
  customStateName?: string;
  customStateColor?: string;
  organization?: string;
  created?: Date;
  createdByName?: string;
  firstContactDate?: Date;
  lastContactDate?: Date;
  lastDocDate?: Date;
  modified?: Date;
  modifiedByName?: string;
  defaultTemplate?: string;
  treeHandle?: string;
  itemId?: string;
  itemName?: string;
  pricing?: string;
  pricingName?: string;
  parent?: string;
  childCount?: string;
  parentRoot?: string;
  userTemplate?: string;
  dimension1?: string;
  dimension1Name?: string;
  dimension2?: string;
  dimension2Name?: string;
  dimension3?: string;
  dimension3Name?: string;
  avalDimension1?: string;
  avalDimension1Name?: string;
  avalDimension2?: string;
  avalDimension2Name?: string;
  avalDimension3?: string;
  avalDimension3Name?: string;
  messageDefaultPath?: string;
  template?: string;
  contact?: string;
  item?: string;
  state?: string;
  folderId?: string;
  keepModified?: string;
  notificationId?: string;
  itemPricing?: string;
  itemPricingName?: string;
  primaryPicture?: string;
  contextParent?: string;
  contextParentName?: string;
  PATH?: Path;
  PROJECTS?: Projects;
  CONTACT?: Contact;
  LOCATION?: Location;
  EXTERNAL_CONTACTS?: ExternalContacts;
  PRIMARYCONTACT?: Contact;
}

export function toFolderXml(folder?: Folder): string {
  var xml = '';

  if (folder) {
    xml += '<FOLDER>';
    xml += SoapUtils.makeNode(folder.parentPath, 'parentPath');
    xml += SoapUtils.makeNode(folder.type, 'type');
    xml += SoapUtils.makeNode(folder.id, 'id');
    xml += SoapUtils.makeNode(folder.aclh, 'aclh');
    xml += SoapUtils.makeNode(folder.comment, 'comment');
    xml += SoapUtils.makeNode(folder.folderType, 'folderType');
    xml += SoapUtils.makeNode(folder.folderLinkType, 'folderLinkType');
    xml += SoapUtils.makeNode(folder.folderTypeName, 'folderTypeName');
    xml += SoapUtils.makeNode(folder.typeFormId, 'typeFormId');
    xml += SoapUtils.makeNode(folder.formId, 'formId');
    xml += SoapUtils.makeNode(folder.formName, 'formName');
    xml += SoapUtils.makeNode(folder.referenceId, 'referenceId');
    xml += SoapUtils.makeNode(folder.name, 'name');
    xml += SoapUtils.makeNode(folder.name1, 'name1');
    xml += SoapUtils.makeNode(folder.name2, 'name2');
    xml += SoapUtils.makeNode(folder.name3, 'name3');
    xml += SoapUtils.makeNode(folder.formValues, 'formValues');
    xml += SoapUtils.makeNode(folder.messageGroup, 'messageGroup');
    xml += SoapUtils.makeNode(folder.messageDefault, 'messageDefault');
    xml += SoapUtils.makeNode(folder.guiAction, 'guiAction');
    xml += SoapUtils.makeNode(folder.contactType, 'contactType');
    xml += SoapUtils.makeNode(folder.customState, 'customState');
    xml += SoapUtils.makeNode(folder.customStateName, 'customStateName');
    xml += SoapUtils.makeNode(folder.customStateColor, 'customStateColor');
    xml += SoapUtils.makeNode(folder.organization, 'organization');
    if(folder.created) xml += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(folder.created), 'created');
    xml += SoapUtils.makeNode(folder.createdByName, 'createdByName');
    if(folder.firstContactDate) xml += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(folder.firstContactDate), 'firstContactDate');
    if(folder.lastContactDate) xml += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(folder.lastContactDate), 'lastContactDate');
    if(folder.lastDocDate) xml += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(folder.lastDocDate), 'lastDocDate');
    if(folder.modified) xml += SoapUtils.makeNode(ConstantUtils.xmlFormatDate(folder.modified), 'modified');
    xml += SoapUtils.makeNode(folder.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(folder.defaultTemplate, 'defaultTemplate');
    xml += SoapUtils.makeNode(folder.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(folder.itemId, 'itemId');
    xml += SoapUtils.makeNode(folder.itemName, 'itemName');
    xml += SoapUtils.makeNode(folder.pricing, 'pricing');
    xml += SoapUtils.makeNode(folder.pricingName, 'pricingName');
    xml += SoapUtils.makeNode(folder.parent, 'parent');
    xml += SoapUtils.makeNode(folder.childCount, 'childCount');
    xml += SoapUtils.makeNode(folder.parentRoot, 'parentRoot');
    xml += SoapUtils.makeNode(folder.userTemplate, 'userTemplate');
    xml += SoapUtils.makeNode(folder.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(folder.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(folder.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(folder.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(folder.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(folder.dimension3Name, 'dimension3Name');
    xml += SoapUtils.makeNode(folder.avalDimension1, 'avalDimension1');
    xml += SoapUtils.makeNode(folder.avalDimension1Name, 'avalDimension1Name');
    xml += SoapUtils.makeNode(folder.avalDimension2, 'avalDimension2');
    xml += SoapUtils.makeNode(folder.avalDimension2Name, 'avalDimension2Name');
    xml += SoapUtils.makeNode(folder.avalDimension3, 'avalDimension3');
    xml += SoapUtils.makeNode(folder.avalDimension3Name, 'avalDimension3Name');
    xml += SoapUtils.makeNode(folder.messageDefaultPath, 'messageDefaultPath');
    xml += SoapUtils.makeNode(folder.template, 'template');
    xml += SoapUtils.makeNode(folder.contact, 'contact');
    xml += SoapUtils.makeNode(folder.item, 'item');
    xml += SoapUtils.makeNode(folder.state, 'state');
    xml += SoapUtils.makeNode(folder.folderId, 'folderId');
    xml += SoapUtils.makeNode(folder.keepModified, 'keepModified');
    xml += SoapUtils.makeNode(folder.notificationId, 'notificationId');
    xml += SoapUtils.makeNode(folder.itemPricing, 'itemPricing');
    xml += SoapUtils.makeNode(folder.itemPricingName, 'itemPricingName');
    xml += SoapUtils.makeNode(folder.primaryPicture, 'primaryPicture');
    xml += SoapUtils.makeNode(folder.contextParent, 'contextParent');
    xml += SoapUtils.makeNode(folder.contextParentName, 'contextParentName');
    if (folder.PATH) xml += toPathXml(folder.PATH);
    if (folder.PROJECTS) xml += toProjectsXml(folder.PROJECTS);
    if (folder.CONTACT) xml += toContactXml(folder.CONTACT);
    if (folder.LOCATION) xml += toLocationXml(folder.LOCATION);
    if (folder.EXTERNAL_CONTACTS) xml += toExternalContactsXml(folder.EXTERNAL_CONTACTS);
    if (folder.PRIMARYCONTACT) xml += toContactXml(folder.PRIMARYCONTACT);
    xml += '</FOLDER>';
  }

  return xml;
}
// export interface Contact {
//     PERSON:  Company[];
//     COMPANY?: Company;
// }

export interface Company {
  id?: string;
  mainContact?: string;
  treeHandle?: string;
  aclh?: string;
  account?: string;
  accresponsiblePerson?: string;
  accresponsibleUserId?: string;
  bankCode?: string;
  bankName?: string;
  category?: string;
  sysUser?: string;
  sysUserName?: string;
  description?: string;
  keyId?: string;
  formId?: string;
  formValues?: string;
  adsAllowed?: string;
  keepContact?: string;
  validFrom?: string;
  validTo?: string;
  created?: string;
  modified?: string;
  createdBy?: string;
  modifiedBy?: string;
  createdByName?: string;
  modifiedByName?: string;
  projectId?: string;
  folderId?: string;
  projectName?: string;
  folderName?: string;
  oldId?: string;
  hash?: string;
  organizationId?: string;
  position?: string;
  positionInfo?: string;
  positionName?: string;
  reference?: string;
  swiftCode?: string;
  sourceDb?: string;
  trackingCode?: string;
  name1?: string;
  name2?: string;
  name3?: string;
  city?: string;
  country?: string;
  email?: string;
  fax?: string;
  icq?: string;
  mobile?: string;
  notSimilarName?: string;
  other?: string;
  linkedin?: string;
  twitter?: string;
  facebook?: string;
  phone?: string;
  pager?: string;
  region?: string;
  street?: string;
  web?: string;
  zip?: string;
  dueDays?: string;
  priority?: string;
  bankIBAN?: string;
  bankNoteForeign?: string;
  consentStatus?: string;
  consentNote?: string;
  anonymized?: string;
  employer?: string;
  adsAllowedFrom?: string;
  massmailEnabledFrom?: string;
  massmailEnabledTo?: string;
  massmailEnabled?: string;
  ADDRESSES?: Addresses;
  CONTACTS?: Contacts;
  BANKS?: Banks;
  DGROUPS?: Dgroups;
  EXTERNAL_IDS?: ExternalIDS;
  company?: string;
  companyName?: string;
  companyOldId?: string;
  configTreeHandle?: string;
  department?: string;
  departmentInfo?: string;
  departmentName?: string;
  isPrimary?: string;
  COMPANYINFO?: Companyinfo;
  INDUSTRIES?: Industries;
  RELATIONS?: Relations;
  FOLDERS?: Folders;
  DOCUMENT?: Document[];
  PERSONINFO?: Personinfo;
  EMPLOYMENTS?: Employments;
}

export function toCompanyXml(company?: Company): string {
  var xml = '';
  if (company) {
    xml += '<COMPANY>';
    xml += SoapUtils.makeNode(company.id, 'id');
    xml += SoapUtils.makeNode(company.mainContact, 'mainContact');
    xml += SoapUtils.makeNode(company.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(company.aclh, 'aclh');
    xml += SoapUtils.makeNode(company.account, 'account');
    xml += SoapUtils.makeNode(company.accresponsiblePerson, 'accresponsiblePerson');
    xml += SoapUtils.makeNode(company.accresponsibleUserId, 'accresponsibleUserId');
    xml += SoapUtils.makeNode(company.bankCode, 'bankCode');
    xml += SoapUtils.makeNode(company.bankName, 'bankName');
    xml += SoapUtils.makeNode(company.category, 'category');
    xml += SoapUtils.makeNode(company.sysUser, 'sysUser');
    xml += SoapUtils.makeNode(company.sysUserName, 'sysUserName');
    xml += SoapUtils.makeNode(company.description, 'description');
    xml += SoapUtils.makeNode(company.keyId, 'keyId');
    xml += SoapUtils.makeNode(company.formId, 'formId');
    xml += SoapUtils.makeNode(company.formValues, 'formValues');
    xml += SoapUtils.makeNode(company.adsAllowed, 'adsAllowed');
    xml += SoapUtils.makeNode(company.keepContact, 'keepContact');
    xml += SoapUtils.makeNode(company.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(company.validTo, 'validTo');
    xml += SoapUtils.makeNode(company.created, 'created');
    xml += SoapUtils.makeNode(company.modified, 'modified');
    xml += SoapUtils.makeNode(company.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(company.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(company.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(company.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(company.projectId, 'projectId');
    xml += SoapUtils.makeNode(company.folderId, 'folderId');
    xml += SoapUtils.makeNode(company.projectName, 'projectName');
    xml += SoapUtils.makeNode(company.folderName, 'folderName');
    xml += SoapUtils.makeNode(company.oldId, 'oldId');
    xml += SoapUtils.makeNode(company.hash, 'hash');
    xml += SoapUtils.makeNode(company.organizationId, 'organizationId');
    xml += SoapUtils.makeNode(company.position, 'position');
    xml += SoapUtils.makeNode(company.positionInfo, 'positionInfo');
    xml += SoapUtils.makeNode(company.positionName, 'positionName');
    xml += SoapUtils.makeNode(company.reference, 'reference');
    xml += SoapUtils.makeNode(company.swiftCode, 'swiftCode');
    xml += SoapUtils.makeNode(company.sourceDb, 'sourceDb');
    xml += SoapUtils.makeNode(company.trackingCode, 'trackingCode');
    xml += SoapUtils.makeNode(company.name1, 'name1');
    xml += SoapUtils.makeNode(company.name2, 'name2');
    xml += SoapUtils.makeNode(company.name3, 'name3');
    xml += SoapUtils.makeNode(company.city, 'city');
    xml += SoapUtils.makeNode(company.country, 'country');
    xml += SoapUtils.makeNode(company.email, 'email');
    xml += SoapUtils.makeNode(company.fax, 'fax');
    xml += SoapUtils.makeNode(company.icq, 'icq');
    xml += SoapUtils.makeNode(company.mobile, 'mobile');
    xml += SoapUtils.makeNode(company.notSimilarName, 'notSimilarName');
    xml += SoapUtils.makeNode(company.other, 'other');
    xml += SoapUtils.makeNode(company.linkedin, 'linkedin');
    xml += SoapUtils.makeNode(company.twitter, 'twitter');
    xml += SoapUtils.makeNode(company.facebook, 'facebook');
    xml += SoapUtils.makeNode(company.phone, 'phone');
    xml += SoapUtils.makeNode(company.pager, 'pager');
    xml += SoapUtils.makeNode(company.region, 'region');
    xml += SoapUtils.makeNode(company.street, 'street');
    xml += SoapUtils.makeNode(company.web, 'web');
    xml += SoapUtils.makeNode(company.zip, 'zip');
    xml += SoapUtils.makeNode(company.dueDays, 'dueDays');
    xml += SoapUtils.makeNode(company.priority, 'priority');
    xml += SoapUtils.makeNode(company.bankIBAN, 'bankIBAN');
    xml += SoapUtils.makeNode(company.bankNoteForeign, 'bankNoteForeign');
    xml += SoapUtils.makeNode(company.consentStatus, 'consentStatus');
    xml += SoapUtils.makeNode(company.consentNote, 'consentNote');
    xml += SoapUtils.makeNode(company.anonymized, 'anonymized');
    xml += SoapUtils.makeNode(company.employer, 'employer');
    xml += SoapUtils.makeNode(company.adsAllowedFrom, 'adsAllowedFrom');
    xml += SoapUtils.makeNode(company.massmailEnabledFrom, 'massmailEnabledFrom');
    xml += SoapUtils.makeNode(company.massmailEnabledTo, 'massmailEnabledTo');
    xml += SoapUtils.makeNode(company.massmailEnabled, 'massmailEnabled');
    if (company.ADDRESSES) xml += toAddressesXml(company.ADDRESSES);
    if (company.CONTACTS) xml += toContactsXml(company.CONTACTS);
    if (company.BANKS) xml += toBanksXml(company.BANKS);
    if (company.DGROUPS) xml += toDgroupsXml(company.DGROUPS);
    if (company.EXTERNAL_IDS) xml += toExternalIdsXml(company.EXTERNAL_IDS);
    xml += SoapUtils.makeNode(company.company, 'company');
    xml += SoapUtils.makeNode(company.companyName, 'companyName');
    xml += SoapUtils.makeNode(company.companyOldId, 'companyOldId');
    xml += SoapUtils.makeNode(company.configTreeHandle, 'configTreeHandle');
    xml += SoapUtils.makeNode(company.department, 'department');
    xml += SoapUtils.makeNode(company.departmentInfo, 'departmentInfo');
    xml += SoapUtils.makeNode(company.departmentName, 'departmentName');
    xml += SoapUtils.makeNode(company.isPrimary, 'isPrimary');
    if (company.COMPANYINFO) xml += toCompanyinfoXml(company.COMPANYINFO);
    if (company.INDUSTRIES) xml += toIndustriesXml(company.INDUSTRIES);
    if (company.RELATIONS) xml += toRelationsXml(company.RELATIONS);
    if (company.FOLDERS) xml += toFoldersXml(company.FOLDERS);
    if (company.DOCUMENT) company.DOCUMENT.forEach(document => (xml += toDocumentXml(document)));
    if (company.PERSONINFO) xml += toPersoninfoXml(company.PERSONINFO);
    if (company.EMPLOYMENTS) xml += toEmploymentsXml(company.EMPLOYMENTS);
    xml += '</COMPANY>';
  }
  return xml;
}

export interface Addresses {
  ADDRESS: Address[];
}

export function toAddressesXml(addresses?: Addresses): string {
  var xml = '';
  if (addresses) {
    xml += '<ADDRESSES>';
    if (addresses.ADDRESS) addresses.ADDRESS.forEach(address => (xml += toAddressXml(address)));
    xml += '</ADDRESSES>';
  }
  return xml;
}

export interface Address {
  city?: string;
  cityName?: string;
  companyAddr?: string;
  country?: string;
  countryName?: string;
  deliveryAddr?: string;
  empAddr?: string;
  invoiceAddr?: string;
  isPrimary?: string;
  permanentAddr?: string;
  personAddr?: string;
  region?: string;
  regionName?: string;
  street?: string;
  temporaryAddr?: string;
  type?: string;
  zip?: string;
  zipName?: string;
}

export function toAddressXml(address?: Address): string {
  var xml = '';
  if (address) {
    xml += '<ADDRESS>';
    xml += SoapUtils.makeNode(address.city, 'city');
    xml += SoapUtils.makeNode(address.cityName, 'cityName');
    xml += SoapUtils.makeNode(address.companyAddr, 'companyAddr');
    xml += SoapUtils.makeNode(address.country, 'country');
    xml += SoapUtils.makeNode(address.countryName, 'countryName');
    xml += SoapUtils.makeNode(address.deliveryAddr, 'deliveryAddr');
    xml += SoapUtils.makeNode(address.empAddr, 'empAddr');
    xml += SoapUtils.makeNode(address.invoiceAddr, 'invoiceAddr');
    xml += SoapUtils.makeNode(address.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(address.permanentAddr, 'permanentAddr');
    xml += SoapUtils.makeNode(address.personAddr, 'personAddr');
    xml += SoapUtils.makeNode(address.region, 'region');
    xml += SoapUtils.makeNode(address.regionName, 'regionName');
    xml += SoapUtils.makeNode(address.street, 'street');
    xml += SoapUtils.makeNode(address.temporaryAddr, 'temporaryAddr');
    xml += SoapUtils.makeNode(address.type, 'type');
    xml += SoapUtils.makeNode(address.zip, 'zip');
    xml += SoapUtils.makeNode(address.zipName, 'zipName');
    xml += '</ADDRESS>';
  }
  return xml;
}

export interface Banks {
  BANK: Bank[];
}

export function toBanksXml(banks?: Banks): string {
  var xml = '';
  if (banks) {
    xml += '<BANKS>';
    if (banks.BANK) banks.BANK.forEach(bank => (xml += toBankXml(bank)));
    xml += '</BANKS>';
  }
  return xml;
}

export interface Bank {
  name?: string;
  bankName?: string;
  account?: string;
  bankCode?: string;
  swiftCode?: string;
  variableSymbol?: string;
  constantSymbol?: string;
  specificSymbol?: string;
  comment?: string;
  isPrimary?: string;
  bankIBAN?: string;
  bankNoteForeign?: string;
}

export function toBankXml(bank?: Bank): string {
  var xml = '';
  if (bank) {
    xml += '<BANK>';
    xml += SoapUtils.makeNode(bank.name, 'name');
    xml += SoapUtils.makeNode(bank.bankName, 'bankName');
    xml += SoapUtils.makeNode(bank.account, 'account');
    xml += SoapUtils.makeNode(bank.bankCode, 'bankCode');
    xml += SoapUtils.makeNode(bank.swiftCode, 'swiftCode');
    xml += SoapUtils.makeNode(bank.variableSymbol, 'variableSymbol');
    xml += SoapUtils.makeNode(bank.constantSymbol, 'constantSymbol');
    xml += SoapUtils.makeNode(bank.specificSymbol, 'specificSymbol');
    xml += SoapUtils.makeNode(bank.comment, 'comment');
    xml += SoapUtils.makeNode(bank.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(bank.bankIBAN, 'bankIBAN');
    xml += SoapUtils.makeNode(bank.bankNoteForeign, 'bankNoteForeign');
    xml += '</BANK>';
  }
  return xml;
}

export interface Companyinfo {
  regNumber?: string;
  VATNumber?: string;
  legalForm?: string;
  legalFormName?: string;
}

export function toCompanyinfoXml(companyinfo?: Companyinfo): string {
  var xml = '';
  if (companyinfo) {
    xml += '<COMPANYINFO>';
    xml += SoapUtils.makeNode(companyinfo.regNumber, 'regNumber');
    xml += SoapUtils.makeNode(companyinfo.VATNumber, 'VATNumber');
    xml += SoapUtils.makeNode(companyinfo.legalForm, 'legalForm');
    xml += SoapUtils.makeNode(companyinfo.legalFormName, 'legalFormName');
    xml += '</COMPANYINFO>';
  }
  return xml;
}

export interface Contacts {
  CONTACT: Contact[];
}

export function toContactsXml(contacts?: Contacts): string {
  var xml = '';
  if (contacts) {
    xml += '<CONTACTS>';
    if (contacts.CONTACT) contacts.CONTACT.forEach(contact => (xml += toContactXml(contact)));
    xml += '</CONTACTS>';
  }
  return xml;
}

export interface Contact {
  content?: string;
  description?: string;
  isMain?: string;
  isPrimary?: string;
  type?: string;
  typeName?: string;
  typeType?: string;
  category?: string;
}

export function toContactXml(contact?: Contact): string {
  var xml = '';
  if (contact) {
    xml += '<CONTACT>';
    xml += SoapUtils.makeNode(contact.content, 'content');
    xml += SoapUtils.makeNode(contact.description, 'description');
    xml += SoapUtils.makeNode(contact.isMain, 'isMain');
    xml += SoapUtils.makeNode(contact.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(contact.type, 'type');
    xml += SoapUtils.makeNode(contact.typeName, 'typeName');
    xml += SoapUtils.makeNode(contact.typeType, 'typeType');
    xml += SoapUtils.makeNode(contact.category, 'category');
    xml += '</CONTACT>';
  }
  return xml;
}

export interface Dgroups {
  DGROUP: Dgroup[];
}

export function toDgroupsXml(dgroups?: Dgroups): string {
  var xml = '';
  if (dgroups) {
    xml += '<DGROUPS>';
    if (dgroups.DGROUP) dgroups.DGROUP.forEach(dgroup => (xml += toDgroupXml(dgroup)));
    xml += '</DGROUPS>';
  }
  return xml;
}

export interface Dgroup {
  id?: string;
  name?: string;
  category?: string;
  comment?: string;
}

export function toDgroupXml(dgroup?: Dgroup): string {
  var xml = '';
  if (dgroup) {
    xml += '<DGROUP>';
    xml += SoapUtils.makeNode(dgroup.id, 'id');
    xml += SoapUtils.makeNode(dgroup.name, 'name');
    xml += SoapUtils.makeNode(dgroup.category, 'category');
    xml += SoapUtils.makeNode(dgroup.comment, 'comment');
    xml += '</DGROUP>';
  }
  return xml;
}

export interface Document {
  documentId?: string;
  name?: string;
  description?: string;
  isPrimaryPicture?: string;
}

export function toDocumentXml(document?: Document): string {
  var xml = '';
  if (document) {
    xml += '<DOCUMENT>';
    xml += SoapUtils.makeNode(document.documentId, 'documentId');
    xml += SoapUtils.makeNode(document.name, 'name');
    xml += SoapUtils.makeNode(document.description, 'description');
    xml += SoapUtils.makeNode(document.isPrimaryPicture, 'isPrimaryPicture');
    xml += '</DOCUMENT>';
  }
  return xml;
}

export interface Employments {
  COMPANY: EmploymentsCompany[];
}

export function toEmploymentsXml(employments?: Employments): string {
  var xml = '';
  if (employments) {
    xml += '<EMPLOYMENTS>';
    if (employments.COMPANY) employments.COMPANY.forEach(company => (xml += toEmploymentsCompanyXml(company)));
    xml += '</EMPLOYMENTS>';
  }
  return xml;
}

export interface EmploymentsCompany {
  id?: string;
  name?: string;
  companyOldId?: string;
  created?: string;
  createdBy?: string;
  department?: string;
  departmentInfo?: string;
  departmentName?: string;
  isPrimary?: string;
  modified?: string;
  modifiedBy?: string;
  position?: string;
  positionInfo?: string;
  positionName?: string;
  reference?: string;
  sourceDb?: string;
  validFrom?: string;
  validTo?: string;
  type?: string;
  originalName?: string;
  custom1?: string;
  custom2?: string;
  custom3?: string;
  FOLDERS?: Folders;
}

export function toEmploymentsCompanyXml(employments_company?: EmploymentsCompany): string {
  var xml = '';

  if (employments_company) {
    xml += '<COMPANY>';
    xml += SoapUtils.makeNode(employments_company.id, 'id');
    xml += SoapUtils.makeNode(employments_company.name, 'name');
    xml += SoapUtils.makeNode(employments_company.companyOldId, 'companyOldId');
    xml += SoapUtils.makeNode(employments_company.created, 'created');
    xml += SoapUtils.makeNode(employments_company.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(employments_company.department, 'department');
    xml += SoapUtils.makeNode(employments_company.departmentInfo, 'departmentInfo');
    xml += SoapUtils.makeNode(employments_company.departmentName, 'departmentName');
    xml += SoapUtils.makeNode(employments_company.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(employments_company.modified, 'modified');
    xml += SoapUtils.makeNode(employments_company.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(employments_company.position, 'position');
    xml += SoapUtils.makeNode(employments_company.positionInfo, 'positionInfo');
    xml += SoapUtils.makeNode(employments_company.positionName, 'positionName');
    xml += SoapUtils.makeNode(employments_company.reference, 'reference');
    xml += SoapUtils.makeNode(employments_company.sourceDb, 'sourceDb');
    xml += SoapUtils.makeNode(employments_company.validFrom, 'validFrom');
    xml += SoapUtils.makeNode(employments_company.validTo, 'validTo');
    xml += SoapUtils.makeNode(employments_company.type, 'type');
    xml += SoapUtils.makeNode(employments_company.originalName, 'originalName');
    xml += SoapUtils.makeNode(employments_company.custom1, 'custom1');
    xml += SoapUtils.makeNode(employments_company.custom2, 'custom2');
    xml += SoapUtils.makeNode(employments_company.custom3, 'custom3');
    if (employments_company.FOLDERS) xml += toFoldersXml(employments_company.FOLDERS);
    xml += '</COMPANY>';
  }

  return xml;
}
export interface Folders {
  FOLDER: Folder[];
}

export function toFoldersXml(folders?: Folders): string {
  var xml = '';
  if (folders) {
    xml += '<FOLDERS>';
    if (folders.FOLDER) folders.FOLDER.forEach(folder => (xml += toFolderXml(folder)));
    xml += '</FOLDERS>';
  }
  return xml;
}

export interface ExternalIDS {
  EXTERNAL_ID: ExternalID[];
}

export function toExternalIdsXml(external_ids?: ExternalIDS): string {
  var xml = '';
  if (external_ids) {
    xml += '<EXTERNAL_IDS>';
    if (external_ids.EXTERNAL_ID) external_ids.EXTERNAL_ID.forEach(external_id => (xml += toExternalIDXml(external_id)));
    xml += '</EXTERNAL_IDS>';
  }
  return xml;
}

export interface ExternalID {
  externalSystem?: string;
  externalId?: string;
}

export function toExternalIDXml(external_id?: ExternalID): string {
  var xml = '';
  if (external_id) {
    xml += '<EXTERNAL_ID>';
    xml += SoapUtils.makeNode(external_id.externalSystem, 'externalSystem');
    xml += SoapUtils.makeNode(external_id.externalId, 'externalId');
    xml += '</EXTERNAL_ID>';
  }
  return xml;
}

export interface Industries {
  INDUSTRY?: Industry[];
}

export function toIndustriesXml(industries?: Industries): string {
  var xml = '';
  if (industries) {
    xml += '<INDUSTRIES>';
    if (industries.INDUSTRY) xml += industries.INDUSTRY.map(ind => toIndustryXml(ind)).join('');
    xml += '</INDUSTRIES>';
  }
  return xml;
}

export interface Industry {
  description?: string;
  industryName?: string;
  industry?: string;
  isPrimary?: string;
}

export function toIndustryXml(industry?: Industry): string {
  var xml = '';
  if (industry) {
    xml += '<INDUSTRY>';
    xml += SoapUtils.makeNode(industry.description, 'description');
    xml += SoapUtils.makeNode(industry.industryName, 'industryName');
    xml += SoapUtils.makeNode(industry.industry, 'industry');
    xml += SoapUtils.makeNode(industry.isPrimary, 'isPrimary');
    xml += '</INDUSTRY>';
  }
  return xml;
}

export interface Personinfo {
  prefixTitle?: string;
  postfixTitle?: string;
  sex?: string;
  sexName?: string;
  maritalStatus?: string;
  born?: string;
  salutation?: string;
  preferedLang?: string;
  nationality?: string;
  nationalityName?: string;
}

export function toPersoninfoXml(personinfo?: Personinfo): string {
  var xml = '';
  if (personinfo) {
    xml += '<PERSONINFO>';
    xml += SoapUtils.makeNode(personinfo.prefixTitle, 'prefixTitle');
    xml += SoapUtils.makeNode(personinfo.postfixTitle, 'postfixTitle');
    xml += SoapUtils.makeNode(personinfo.sex, 'sex');
    xml += SoapUtils.makeNode(personinfo.sexName, 'sexName');
    xml += SoapUtils.makeNode(personinfo.maritalStatus, 'maritalStatus');
    xml += SoapUtils.makeNode(personinfo.born, 'born');
    xml += SoapUtils.makeNode(personinfo.salutation, 'salutation');
    xml += SoapUtils.makeNode(personinfo.preferedLang, 'preferedLang');
    xml += SoapUtils.makeNode(personinfo.nationality, 'nationality');
    xml += SoapUtils.makeNode(personinfo.nationalityName, 'nationalityName');
    xml += '</PERSONINFO>';
  }
  return xml;
}

export interface Relations {
  RELATION: Relation[];
}

export function toRelationsXml(relations?: Relations): string {
  var xml = '';
  if (relations) {
    xml += '<RELATIONS>';
    if (relations.RELATION) relations.RELATION.forEach(relation => (xml += toRelation(relation)));
    xml += '</RELATIONS>';
  }
  return xml;
}

export interface Relation {
  id?: string;
  name?: string;
  company?: string;
  contact?: string;
  rSwap?: string;
  typeName?: string;
  type?: string;
  contact1Id?: string;
  contact2Id?: string;
  contact1Name1?: string;
  contact1Name2?: string;
  contact1Name3?: string;
  contact2Name1?: string;
  contact2Name2?: string;
  contact2Name3?: string;
  contact1Phone?: string;
  contact2Phone?: string;
  contact1Email?: string;
  contact2Email?: string;
  description?: string;
  relation?: string;
  typeName1?: string;
  typeName2?: string;
  rtype?: string;
  c1created?: string;
  c1createdBy?: string;
  c1modified?: string;
  c1modifiedBy?: string;
  c2created?: string;
  c2createdBy?: string;
  c2modified?: string;
  c2modifiedBy?: string;
  contact1OldId?: string;
  contact2OldId?: string;
  SUBJECT?: Subject;
}

export function toRelation(relation: Relation): string {
  var xml = '';
  if (relation) {
    xml += '<RELATION>';
    xml += SoapUtils.makeNode(relation.id, 'id');
    xml += SoapUtils.makeNode(relation.name, 'name');
    xml += SoapUtils.makeNode(relation.company, 'company');
    xml += SoapUtils.makeNode(relation.contact, 'contact');
    xml += SoapUtils.makeNode(relation.rSwap, 'rSwap');
    xml += SoapUtils.makeNode(relation.typeName, 'typeName');
    xml += SoapUtils.makeNode(relation.type, 'type');
    xml += SoapUtils.makeNode(relation.contact1Id, 'contact1Id');
    xml += SoapUtils.makeNode(relation.contact2Id, 'contact2Id');
    xml += SoapUtils.makeNode(relation.contact1Name1, 'contact1Name1');
    xml += SoapUtils.makeNode(relation.contact1Name2, 'contact1Name2');
    xml += SoapUtils.makeNode(relation.contact1Name3, 'contact1Name3');
    xml += SoapUtils.makeNode(relation.contact2Name1, 'contact2Name1');
    xml += SoapUtils.makeNode(relation.contact2Name2, 'contact2Name2');
    xml += SoapUtils.makeNode(relation.contact2Name3, 'contact2Name3');
    xml += SoapUtils.makeNode(relation.contact1Phone, 'contact1Phone');
    xml += SoapUtils.makeNode(relation.contact2Phone, 'contact2Phone');
    xml += SoapUtils.makeNode(relation.contact1Email, 'contact1Email');
    xml += SoapUtils.makeNode(relation.contact2Email, 'contact2Email');
    xml += SoapUtils.makeNode(relation.description, 'description');
    xml += SoapUtils.makeNode(relation.relation, 'relation');
    xml += SoapUtils.makeNode(relation.typeName1, 'typeName1');
    xml += SoapUtils.makeNode(relation.typeName2, 'typeName2');
    xml += SoapUtils.makeNode(relation.rtype, 'rtype');
    xml += SoapUtils.makeNode(relation.c1created, 'c1created');
    xml += SoapUtils.makeNode(relation.c1createdBy, 'c1createdBy');
    xml += SoapUtils.makeNode(relation.c1modified, 'c1modified');
    xml += SoapUtils.makeNode(relation.c1modifiedBy, 'c1modifiedBy');
    xml += SoapUtils.makeNode(relation.c2created, 'c2created');
    xml += SoapUtils.makeNode(relation.c2createdBy, 'c2createdBy');
    xml += SoapUtils.makeNode(relation.c2modified, 'c2modified');
    xml += SoapUtils.makeNode(relation.c2modifiedBy, 'c2modifiedBy');
    xml += SoapUtils.makeNode(relation.contact1OldId, 'contact1OldId');
    xml += SoapUtils.makeNode(relation.contact2OldId, 'contact2OldId');
    if (relation.SUBJECT) xml += toSubjectXml(relation.SUBJECT);
    xml += '</RELATION>';
  }

  return xml;
}

export interface Subject {
  id?: string;
  name?: string;
  type?: string;
}

export function toSubjectXml(subject?: Subject): string {
  var xml = '';
  if (subject) {
    xml += '<SUBJECT>';
    xml += SoapUtils.makeNode(subject.id, 'id');
    xml += SoapUtils.makeNode(subject.name, 'name');
    xml += SoapUtils.makeNode(subject.type, 'type');
    xml += '</SUBJECT>';
  }
  return xml;
}

export interface ExternalContacts {
  count?: string;
  EXTERNAL_CONTACT: ExternalContact[];
}

export function toExternalContactsXml(externalContacts?: any): string {
  var xml = '';
  if (externalContacts.ROWS) {
    xml += '<EXTERNAL_CONTACTS>';
    xml += SoapUtils.makeNode(externalContacts.count, 'count');
    if (externalContacts) externalContacts.ROWS.forEach((externalContact: any) => (xml += toExternalContactXml(externalContact)));
    xml += '</EXTERNAL_CONTACTS>';
  }
  return xml;
}

export interface ExternalContact {
  id?: string;
  contextId?: string;
  contactId?: string;
  note?: string;
  isPrimary?: string;
  role?: string;
  relationshipLevel?: string;
  deleteContact?: string;
  name1?: string;
  name2?: string;
  name3?: string;
  type?: string;
  email?: string;
  phone?: string;
  mobile?: string;
}

export function toExternalContactXml(externalContact?: any): string {
  var xml = '';
  if (externalContact) {
    xml += '<EXTERNAL_CONTACT>';
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.id, 'id');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.contextId, 'contextId');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.contactId, 'contactId');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.note, 'note');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.isPrimary, 'isPrimary');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.role, 'role');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.relationshipLevel, 'relationshipLevel');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.deleteContact, 'deleteContact');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.name1, 'name1');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.name2, 'name2');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.name3, 'name3');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.type, 'type');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.email, 'email');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.phone, 'phone');
    xml += SoapUtils.makeNode(externalContact.EXTERNAL_CONTACT.mobile, 'mobile');
    xml += '</EXTERNAL_CONTACT>';
  }
  return xml;
}

export interface Location {
  longitude?: string;
  latitude?: string;
  TAG?: string;
}

export function toLocationXml(location?: Location): string {
  var xml = '';
  if (location) {
    xml += '<LOCATION>';
    xml += SoapUtils.makeNode(location.longitude, 'longitude');
    xml += SoapUtils.makeNode(location.latitude, 'latitude');
    xml += SoapUtils.makeNode(location.TAG, 'TAG');
    xml += '</LOCATION>';
  }
  return xml;
}

export interface Path {
  result?: string;
  NODE?: Node;
}

export function toPathXml(path?: Path): string {
  var xml = '';
  if (path) {
    xml += '<PATH>';
    xml += SoapUtils.makeNode(path.result, 'result');
    if (path.NODE) xml += toNodeXml(path.NODE);
    xml += '</PATH>';
  }

  return xml;
}

export interface Node {
  id?: string;
  name?: string;
  module?: string;
  parent?: string;
  type?: string;
  NODE?: Node;
}

export function toNodeXml(node?: Node): string {
  var xml = '';
  if (node) {
    xml += '<NODE>';
    xml += SoapUtils.makeNode(node.id, 'id');
    xml += SoapUtils.makeNode(node.name, 'name');
    xml += SoapUtils.makeNode(node.module, 'module');
    xml += SoapUtils.makeNode(node.parent, 'parent');
    xml += SoapUtils.makeNode(node.type, 'type');
    if (node.NODE) xml += toNodeXml(node.NODE);
    xml += '</NODE>';
  }

  return xml;
}
export interface Projects {
  PROJECT: Project[];
}

export function toProjectsXml(projects?: Projects): string {
  var xml = '';
  if (projects) {
    xml += '<PROJECTS>';
    if (projects.PROJECT) projects.PROJECT.forEach(project => (xml += toProjectXml(project)));
    xml += '</PROJECTS>';
  }
  return xml;
}

export interface Project {
  aclh?: string;
  archived?: string;
  comment?: string;
  created?: Date;
  createdBy?: string;
  createdByName?: string;
  customer?: string;
  customerName?: string;
  customState?: string;
  customStateName?: string;
  customStateColor?: string;
  chargeable?: string;
  defaultMessageContainer?: string;
  defaultMessageContainerPath?: string;
  defaultMessageGroup?: string;
  dimension1?: string;
  dimension1Name?: string;
  dimension2?: string;
  dimension2Name?: string;
  dimension3?: string;
  dimension3Name?: string;
  folder?: string;
  folderName?: string;
  folderType?: string;
  folderTypeName?: string;
  formId?: string;
  formName?: string;
  formValues?: string;
  guiAction?: string;
  id?: string;
  internalFolder?: string;
  invoiceJournal?: string;
  invoiceJournalName?: string;
  isMasterProject?: string;
  keepModified?: string;
  firstContactDate?: string;
  lastContactDate?: string;
  lastDocDate?: string;
  masterFolderId?: string;
  masterFolderName?: string;
  masterFolderTypeName?: string;
  masterProjectId?: string;
  masterProjectName?: string;
  masterProjectTypeName?: string;
  contractPlanId?: string;
  currentPlanId?: string;
  modified?: Date;
  modifiedBy?: string;
  modifiedByName?: string;
  name?: string;
  nameInMaster?: string;
  nameSearch?: string;
  notificationId?: string;
  organization?: string;
  pricing?: string;
  pricingName?: string;
  primaryContact?: string;
  primaryContactName?: string;
  projectTemplate?: string;
  projectType?: string;
  projectTypeName?: string;
  provider?: string;
  providerName?: string;
  refId?: string;
  responsible?: string;
  responsibleName?: string;
  state?: string;
  team?: string;
  templateAclh?: string;
  treeHandle?: string;
  typeFormId?: string;
  priority?: string;
  rtsProjectHash?: string;
  sla?: string;
  itemPricing?: string;
  itemPricingName?: string;
  trackingCode?: string;
  contextParent?: string;
  contextParentName?: string;
  item?: string;
  EXTERNAL_CONTACTS?: ExternalContacts;
  PRIMARYCONTACT?: Contact;
  LOCATION?: Location;
  EXTERNAL_IDS?: ExternalIDS;
}

export function toProjectXml(project?: Project): string {
  var xml = '';
  if (project) {
    xml += '<PROJECT>';
    xml += SoapUtils.makeNode(project.aclh, 'aclh');
    xml += SoapUtils.makeNode(project.archived, 'archived');
    xml += SoapUtils.makeNode(project.comment, 'comment');
    xml += SoapUtils.makeNode(project.created, 'created');
    xml += SoapUtils.makeNode(project.createdBy, 'createdBy');
    xml += SoapUtils.makeNode(project.createdByName, 'createdByName');
    xml += SoapUtils.makeNode(project.customer, 'customer');
    xml += SoapUtils.makeNode(project.customerName, 'customerName');
    xml += SoapUtils.makeNode(project.customState, 'customState');
    xml += SoapUtils.makeNode(project.customStateName, 'customStateName');
    xml += SoapUtils.makeNode(project.customStateColor, 'customStateColor');
    xml += SoapUtils.makeNode(project.chargeable, 'chargeable');
    xml += SoapUtils.makeNode(project.defaultMessageContainer, 'defaultMessageContainer');
    xml += SoapUtils.makeNode(project.defaultMessageContainerPath, 'defaultMessageContainerPath');
    xml += SoapUtils.makeNode(project.defaultMessageGroup, 'defaultMessageGroup');
    xml += SoapUtils.makeNode(project.dimension1, 'dimension1');
    xml += SoapUtils.makeNode(project.dimension1Name, 'dimension1Name');
    xml += SoapUtils.makeNode(project.dimension2, 'dimension2');
    xml += SoapUtils.makeNode(project.dimension2Name, 'dimension2Name');
    xml += SoapUtils.makeNode(project.dimension3, 'dimension3');
    xml += SoapUtils.makeNode(project.dimension3Name, 'dimension3Name');
    xml += SoapUtils.makeNode(project.folder, 'folder');
    xml += SoapUtils.makeNode(project.folderName, 'folderName');
    xml += SoapUtils.makeNode(project.folderType, 'folderType');
    xml += SoapUtils.makeNode(project.folderTypeName, 'folderTypeName');
    xml += SoapUtils.makeNode(project.formId, 'formId');
    xml += SoapUtils.makeNode(project.formName, 'formName');
    xml += SoapUtils.makeNode(project.formValues, 'formValues');
    xml += SoapUtils.makeNode(project.guiAction, 'guiAction');
    xml += SoapUtils.makeNode(project.id, 'id');
    xml += SoapUtils.makeNode(project.internalFolder, 'internalFolder');
    xml += SoapUtils.makeNode(project.invoiceJournal, 'invoiceJournal');
    xml += SoapUtils.makeNode(project.invoiceJournalName, 'invoiceJournalName');
    xml += SoapUtils.makeNode(project.isMasterProject, 'isMasterProject');
    xml += SoapUtils.makeNode(project.keepModified, 'keepModified');
    xml += SoapUtils.makeNode(project.firstContactDate, 'firstContactDate');
    xml += SoapUtils.makeNode(project.lastContactDate, 'lastContactDate');
    xml += SoapUtils.makeNode(project.lastDocDate, 'lastDocDate');
    xml += SoapUtils.makeNode(project.masterFolderId, 'masterFolderId');
    xml += SoapUtils.makeNode(project.masterFolderName, 'masterFolderName');
    xml += SoapUtils.makeNode(project.masterFolderTypeName, 'masterFolderTypeName');
    xml += SoapUtils.makeNode(project.masterProjectId, 'masterProjectId');
    xml += SoapUtils.makeNode(project.masterProjectName, 'masterProjectName');
    xml += SoapUtils.makeNode(project.masterProjectTypeName, 'masterProjectTypeName');
    xml += SoapUtils.makeNode(project.contractPlanId, 'contractPlanId');
    xml += SoapUtils.makeNode(project.currentPlanId, 'currentPlanId');
    xml += SoapUtils.makeNode(project.modified, 'modified');
    xml += SoapUtils.makeNode(project.modifiedBy, 'modifiedBy');
    xml += SoapUtils.makeNode(project.modifiedByName, 'modifiedByName');
    xml += SoapUtils.makeNode(project.name, 'name');
    xml += SoapUtils.makeNode(project.nameInMaster, 'nameInMaster');
    xml += SoapUtils.makeNode(project.nameSearch, 'nameSearch');
    xml += SoapUtils.makeNode(project.notificationId, 'notificationId');
    xml += SoapUtils.makeNode(project.organization, 'organization');
    xml += SoapUtils.makeNode(project.pricing, 'pricing');
    xml += SoapUtils.makeNode(project.pricingName, 'pricingName');
    xml += SoapUtils.makeNode(project.primaryContact, 'primaryContact');
    xml += SoapUtils.makeNode(project.primaryContactName, 'primaryContactName');
    xml += SoapUtils.makeNode(project.projectTemplate, 'projectTemplate');
    xml += SoapUtils.makeNode(project.projectType, 'projectType');
    xml += SoapUtils.makeNode(project.projectTypeName, 'projectTypeName');
    xml += SoapUtils.makeNode(project.provider, 'provider');
    xml += SoapUtils.makeNode(project.providerName, 'providerName');
    xml += SoapUtils.makeNode(project.refId, 'refId');
    xml += SoapUtils.makeNode(project.responsible, 'responsible');
    xml += SoapUtils.makeNode(project.responsibleName, 'responsibleName');
    xml += SoapUtils.makeNode(project.state, 'state');
    xml += SoapUtils.makeNode(project.team, 'team');
    xml += SoapUtils.makeNode(project.templateAclh, 'templateAclh');
    xml += SoapUtils.makeNode(project.treeHandle, 'treeHandle');
    xml += SoapUtils.makeNode(project.typeFormId, 'typeFormId');
    xml += SoapUtils.makeNode(project.priority, 'priority');
    xml += SoapUtils.makeNode(project.rtsProjectHash, 'rtsProjectHash');
    xml += SoapUtils.makeNode(project.sla, 'sla');
    xml += SoapUtils.makeNode(project.itemPricing, 'itemPricing');
    xml += SoapUtils.makeNode(project.itemPricingName, 'itemPricingName');
    xml += SoapUtils.makeNode(project.trackingCode, 'trackingCode');
    xml += SoapUtils.makeNode(project.contextParent, 'contextParent');
    xml += SoapUtils.makeNode(project.contextParentName, 'contextParentName');
    xml += SoapUtils.makeNode(project.item, 'item');
    if (project.EXTERNAL_CONTACTS) xml += toExternalContactsXml(project.EXTERNAL_CONTACTS);
    if (project.PRIMARYCONTACT) xml += toContactXml(project.PRIMARYCONTACT);
    if (project.LOCATION) xml += toLocationXml(project.LOCATION);
    if (project.EXTERNAL_IDS) xml += toExternalIdsXml(project.EXTERNAL_IDS);
    xml += '</PROJECT>';
  }
  return xml;
}
